import { useQuery } from "@tanstack/react-query";

import { useToasts } from "app/pages/activation/hooks/helpers/useToasts";
import { translate } from "app/filters/i18nFilter";
import { createActivationApi } from "app/pages/activation/services/api";
import type { TopicParams } from "app/pages/activation/types/api";

export const TOPICS_QUERY_KEY = "ACTIVATION_TOPICS";

export const useGetTopicsDataQuery = (params: TopicParams, isShouldFetch: boolean) => {
    const { showErrorToast } = useToasts();

    return useQuery({
        queryKey: [TOPICS_QUERY_KEY, params.granularity, params.activationId],
        queryFn: () => {
            try {
                const api = createActivationApi();

                return api.topics.get(params);
            } catch (error) {
                showErrorToast(translate("common.api.error", { error: error?.message }));
            }
        },
        staleTime: Infinity,
        enabled: isShouldFetch,
    });
};
